import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Product } from '@app/core/business/product/product';
import { ProductAvailability } from '@app/core/business/product/product-availability';

@Component({
  selector: 'app-stock-indicator',
  templateUrl: './stock-indicator.component.html',
  styleUrls: ['./stock-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockIndicatorComponent {
  @Input()
  public productCode: string;
  /**
   * CLA le 10/10/2019 - A/B - passage d'un texte pour décrire une indisponibilité produit
   */
  @Input()
  public availability: ProductAvailability;
  @Input()
  public updating: boolean;
  @Input()
  public product: Product;

  public hasDate(): boolean {
    if (!this.availability || !this.availability.text) {
      return false;
    }
    return this.availability.text.includes('/') && /\d{2}\/\d{2}/.test(this.availability.text);
  }
}
